<div _ngcontent-oly-c325="" class="html-body ng-star-inserted">
    <p><strong>Métodos de Pago para Inscripciones&nbsp;</strong></p>

    <p>Hemos optimizado las opciones de pago para residentes en Argentina y para participantes internacionales,
        permitiendo una experiencia ágil y adaptada a cada necesidad:&nbsp;</p>

    <p>&nbsp;</p>

    <p><img alt="" src="https://wadmin.uca.edu.ar/public/MEDICAS/2025/Mercado%20Libre.png">&nbsp;</p>

    <p>&nbsp;</p>

    <p><strong>Para Residentes en Argentina:</strong>&nbsp;Los argentinos y/o residentes, pueden realizar el pago de su
        inscripción en pesos argentinos a través de Mercado Pago, con la posibilidad de financiar en 3 o hasta 6 cuotas
        sin interés.&nbsp;&nbsp;</p>

    <p>&nbsp;</p>

    <p><img alt="" src="https://wadmin.uca.edu.ar/public/MEDICAS/2025/Payway.png"></p>

    <p>&nbsp;</p>

    <p><strong>Para estudiantes extranjeros:&nbsp;</strong>Los estudiantes que residen fuera de Argentina tienen a
        disposición el sistema Payway, una opción diseñada específicamente para pagos internacionales. La inscripción
        deberá abonarse en un pago único.&nbsp;</p>

    <p><strong>Importante:&nbsp;</strong>Todos los pagos se efectúan en pesos argentinos. Si abonas desde el exterior,
        tu entidad bancaria realizará la conversión de moneda aplicando sus políticas y tasas de cambio
        correspondientes.&nbsp;</p>

    <p>&nbsp;</p>

    <p *ngIf="posgrados"><a [href]="linkPosg">VIDEO DE COMO
            ABONAR
            LA DIPLOMATURA&nbsp;</a></p>

    <p *ngIf="continua"><a [href]="linkContinua">VIDEO DE COMO
            ABONAR
            LA DIPLOMATURA &nbsp;</a></p>
</div>